export default __webpack_public_path__ + "static/Azuki-570766066e7a435406239b892ae4dc35.png";